export const FACEBOOK_LEAD_DISTRIBUTION_FORM = "marketplaceFacebookLeadDistributionForm";
export const FACEBOOK_LEAD_PAGE_FORM = "marketplaceFacebookLeadPageForm";
export const NEW_FACEBOOK_LEAD_PAGE_FORM = "marketplaceNewFacebookLeadPageForm";
export const EDIT_FACEBOOK_LEAD_PAGE_FORM = "marketplaceEditFacebookLeadPageForm";